//react
import { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";

//css
import styled from "styled-components";
import { M, MMinus, MPlus, T } from "../../../utils/MT";

// component
import MyInquiry from "./components/MyInquiry";
import DefaultModal from "../../../component/popup/DefaultModal";
import modalScroll from "../../../utils/ModalScroll";
import BasicBtn from "../../../component/button/BasicBtn";

export default function MyInquiryPage() {
    //페이지 이동
    const navigate = useNavigate();

    // 접수완료 모달
    const [completeModal, setCompleteModal] = useState(false);
    // 1. 문의 삭제 팝업
    const completeContent = () => {
        return (
            <ModalBox>
                <ConTitle>문의가 성공적으로 접수되었습니다.</ConTitle>
                <BtnSmallWrap>
                    <BasicBtn
                        text="닫기"
                        gray={true}
                        black={true}
                        onClick={() => {
                            setCompleteModal(false);
                            modalScroll.modalClosed();
                            navigate("/mypage/myinquiry");
                        }}
                    />
                </BtnSmallWrap>
            </ModalBox>
        );
    };

    return (
        <>
            <MyInquiry setCompleteModal={setCompleteModal} />

            {completeModal && <DefaultModal closeModal={() => setCompleteModal(false)} contents={completeContent} />}
        </>
    );
}

// 팝업 스타일링
const ModalBox = styled.div`
    width: calc(100vw * (400 / 1920));

    text-align: center;

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (400 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: auto;
    }
`;
const ConTitle = styled.div`
    font-size: calc(100vw * (15 / 1920));

    margin-bottom: calc(100vw * (30 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (15 / 1300));

        margin-bottom: calc(100vw * (30 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(14)};

        margin-bottom: ${M(15)};
    }
`;

const BtnSmallWrap = styled.div`
    display: flex;
    align-items: center;

    width: calc(100vw * (100 / 1920));
    margin: 0 auto;

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (100 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: ${M(160)};
    }
`;
